function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.75425,
  cy: 7.99937,
  r: 6.58824,
  fill: "#EB6469",
  fillOpacity: 0.1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6169 6.19732C11.9098 5.90443 11.9098 5.42956 11.6169 5.13666C11.324 4.84377 10.8492 4.84377 10.5563 5.13666L11.6169 6.19732ZM5.88959 9.80333C5.5967 10.0962 5.5967 10.5711 5.88959 10.864C6.18248 11.1569 6.65736 11.1569 6.95025 10.864L5.88959 9.80333ZM6.95025 5.13666C6.65736 4.84377 6.18248 4.84377 5.88959 5.13666C5.5967 5.42956 5.5967 5.90443 5.88959 6.19732L6.95025 5.13666ZM10.5563 10.864C10.8492 11.1569 11.324 11.1569 11.6169 10.864C11.9098 10.5711 11.9098 10.0962 11.6169 9.80333L10.5563 10.864ZM10.5563 5.13666L8.22293 7.47L9.28359 8.53066L11.6169 6.19732L10.5563 5.13666ZM8.22293 7.47L5.88959 9.80333L6.95025 10.864L9.28359 8.53066L8.22293 7.47ZM5.88959 6.19732L8.22293 8.53066L9.28359 7.47L6.95025 5.13666L5.88959 6.19732ZM8.22293 8.53066L10.5563 10.864L11.6169 9.80333L9.28359 7.47L8.22293 8.53066Z",
  fill: "#EB6469"
});

function SvgXRoundAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXRoundAlt);
export default __webpack_public_path__ + "static/media/x-round-alt.8f353c7e.svg";
export { ForwardRef as ReactComponent };